import { apiSlice } from "../../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDatasource: builder.query({
      query: () => ({
        url: "/connectpg/getdataSources",
        method: "GET",
      }),
    }),
    deleteDataSource: builder.mutation({
      query: (ID) => ({
        url: "/connectpg/delete",
        method: "DELETE",
        body: { connectionId: ID },
      }),
      invalidatesTags: (result, error, { ID }) => [
        { type: "DataSource", id: ID },
      ],
    }),
    getSingleDS: builder.mutation({
      query: (body) => {
        // console.log(dataSourceId);
        return {
          url: "connectpg/getDataSourceDetails",
          method: "POST",
          body,
        };
      },
    }),
    editDataSource: builder.mutation({
      query: (payload) => {
        // console.log(payload);
        return {
          url: "/connectpg/editDataSource",
          method: "PATCH",
          body: payload,
        };
      },
      invalidatesTags: (result, error, { id }) => [{ type: "DataSource", id }],
    }),
    addRowLevelAccess: builder.mutation({
      query: (payload) => {
        // console.log(payload);
        return {
          url: "/connectpg/addrowlevelaccess",
          method: "PATCH",
          body: payload,
        };
      },
      invalidatesTags: (result, error, { id }) => [{ type: "DataSource", id }],
    }),
    refetchColumnsDetails: builder.mutation({
      query: (dataSourceID) => {
        // console.log(dataSourceID);
        return {
          url: "connectDatabase/refetchColumnDetails",
          method: "POST",
          body: { dataSourceID },
        };
      },
    }),
    postAccessWorkbook: builder.mutation({
      query: (payload) => ({
        url: "/acess/workbook",
        method: "POST",
        body: payload,
      }),
    }),
    updateDatabaseAccess: builder.mutation({
      query: (payload) => {
        return {
          url: "/datasource/access",
          method: "POST",
          body: payload,
        };
      },
    }),
    getAccessDataSource: builder.mutation({
      query: (dataSource) => ({
        url: `/datasource/access/datasources`,
        method: "POST",
        body: { dataSource: dataSource },
      }),
    }),
    createMeeting: builder.mutation({
      query: (object) => ({
        url: "/sqlTable/save",
        method: "POST",
        body: object,
      }),
      invalidatesTags: ["Meetings"],
    }),
    editMeeting: builder.mutation({
      query: (object) => ({
        url: "/sqlTable/Edit",
        method: "POST",
        body: object,
      }),
      invalidatesTags: ["Meetings"],
    }),
    getMeetings: builder.mutation({
      query: (object) => ({
        url: "/sqlTable/getMeetings",
        method: "POST",
        body: object,
      }),
      providesTags: ["Meetings"],
    }),
    assignPermission: builder.mutation({
      query: (payload) => {
        return {
          url: "/datasource/update-permission-type",
          method: "POST",
          body: payload,
        };
      },
    }),
    getWorkbooks: builder.mutation({
      query: (workbookId) => {
        // console.log(
        //   "Payload being sent to /workbooks/getworkbook:",
        //   workbookId
        // );
        return {
          url: "/workbooks/getworkbook",
          method: "POST",
          body: { workbookId },
        };
      },
    }),
    assignWorkbookAccess: builder.mutation({
      query: (payload) => ({
        url: "/acess/workbook",
        method: "POST",
        body: payload,
      }),
    }),
    assignWorkbookpermission: builder.mutation({
      query: (payload) => ({
        url: "/acess/accesworkbook",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetDatasourceQuery,
  useEditDataSourceMutation,
  useAddRowLevelAccessMutation,
  useDeleteDataSourceMutation,
  useGetSingleDSMutation,
  useRefetchColumnsDetailsMutation,
  usePostAccessWorkbookMutation,
  useUpdateDatabaseAccessMutation,
  useGetAccessDataSourceMutation,
  useCreateMeetingMutation,
  useEditMeetingMutation,
  useGetMeetingsMutation,
  useAssignPermissionMutation,
  useGetWorkbooksMutation,
  useAssignWorkbookAccessMutation,
  useAssignWorkbookpermissionMutation,
} = sqlApiSlice;
